<template>
  <v-row justify="center" class="ma-2">
    <v-dialog v-model="dialog" width="100%" height="100%" light fullscreen>
      <template v-slot:activator="{ on }">
        <v-btn small text color="orange" rounded v-on="on"
          >VIEW/EDIT RESPONSES</v-btn
        >
      </template>

      <div>
        <!-- <v-card
          flat
          outlined
          style="background-color: black; border-radius: 26px; border: 3px solid #a07800"
        >-->
        <v-card
          flat
          outlined
          style="border-radius: 26px; border: 3px solid #a07800"
        >
          <v-card-actions>
            <v-btn :disabled="windowStep === 1" text @click="windowStep--"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn tile rounded color="red" @click="dialog = false">Exit</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="windowStep === windowSteps"
              color="primary"
              depressed
              @click="windowStep++"
              rounded
              outlined
              dark
              >Next</v-btn
            >

            <!-- experimental -->
            <!-- <v-btn
                          :disabled="windowStep === windowSteps"
                          color="primary"
                          depressed
                          @click="saveAndContinue"
                          rounded
                          outlined
                          dark
                          >Next</v-btn
            >-->
          </v-card-actions>
          <v-card-title class="title font-weight-regular justify-space-between">
            <!-- <span style="overflow-wrap: normal">{{ currentTitle }}</span> -->
            <!-- <v-avatar
                          color="black"
                          class="subheading white--text font-weight-bold"
                          size="34"
                          v-text="windowStep"
            ></v-avatar>-->
            <!-- <div class="yellow--text">{{ formTitle }}</div> -->
            <div>{{ formTitle }}</div>
            <v-spacer></v-spacer>
            <div class="headline red--text font-weight-bold">
              {{ windowStep }}/{{ windowSteps }}
            </div>
          </v-card-title>
          <v-window v-model="windowStep" style="overflow-x: scroll" continuous>
            <div v-for="(q, i) in clientResponses" :key="i">
              <v-window-item :value="i + 1">
                <v-card-text v-if="q.type === 'address'" class="ma-auto">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>

                  <v-text-field
                    color="#a07800"
                    style="max-width: 500px"
                    class="ma-auto"
                    outlined
                    label="Place Your Response Here"
                    v-model="q.response"
                    clearable
                  ></v-text-field>
                </v-card-text>
                <v-card-text v-if="q.type === 'date'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>

                  <v-textarea
                    :rules="[rules.length(1400)]"
                    counter="1400"
                    label="Place Your Response Here"
                    v-model="q.response"
                    color="#a07800"
                    style="max-width: 700px"
                    class="ma-auto"
                    outlined
                    hint="DD/MM/YYYY"
                    clearable
                    auto-grow
                  ></v-textarea>
                </v-card-text>
                <v-card-text v-if="q.type === 'textArea'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>
                  <!-- try something here with a WYSIWYG -->
                  <!-- <ckeditor :editor="editor" v-model="q.response"></ckeditor> -->
                  <!-- <v-btn @click="emptyEditor">Empty the editor</v-btn> -->

                  <v-textarea
                    type="textarea"
                    :rules="[rules.length(1400)]"
                    counter="1400"
                    color="#a07800"
                    style="max-width: 700px"
                    class="ma-auto"
                    outlined
                    label="Place Your Response Here"
                    v-model="q.response"
                    clearable
                    auto-grow
                  ></v-textarea>
                </v-card-text>
                <v-card-text v-if="q.type === 'listOfNames'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>
                  <v-text-field
                    :rules="[rules.length(1400)]"
                    counter="1400"
                    label="Place Your Response Here"
                    v-model="tempListItem"
                    color="#a07800"
                    style="max-width: 500px"
                    class="ma-auto"
                    outlined
                    hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                    clearable
                  ></v-text-field>
                  <v-layout>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="!tempListItem"
                      rounded
                      outlined
                      color="green"
                      samll
                      @click="addResponseToList(i)"
                    >
                      <v-icon>mdi-plus</v-icon>ADD
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-layout>

                  <v-layout column class="ma-2">
                    <div class="ma-2 text-center title">Current List</div>
                    <div
                      class="ma-2 text-center subtitle-1"
                      v-for="(r, index) in q.response"
                      :key="index"
                    >
                      {{ index + 1 }} - {{ r }}
                      <v-btn
                        class="ma-2"
                        rounded
                        outlined
                        color="red"
                        small
                        @click="removeResponseFromList(i, index)"
                        >remove</v-btn
                      >
                    </div>
                  </v-layout>
                </v-card-text>
                <v-card-text v-if="q.type === 'dependantBoolTrue'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>
                  <v-radio-group v-model="q.response">
                    <v-radio label="YES" value="true"></v-radio>
                    <v-radio
                      label="NO"
                      value="false"
                      @click="clearDependantQuestionResponse(i)"
                    ></v-radio>
                  </v-radio-group>
                  <v-expand-transition>
                    <div v-if="q.response === 'true'">
                      <div class="ma-4 title font-weight-regular text-center">
                        {{ q.dependantQuestion.text }}
                      </div>
                      <div v-if="q.dependantQuestion.type === 'textArea'">
                        <v-textarea
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          color="#a07800"
                          style="max-width: 700px"
                          class="ma-auto"
                          outlined
                          label="Place Your Response Here"
                          v-model="q.dependantQuestion.response"
                          clearable
                          auto-grow
                        ></v-textarea>
                      </div>
                      <div v-if="q.dependantQuestion.type === 'subListOfNames'">
                        <v-textarea
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          label="Place Your Response Here"
                          v-model="tempListItem"
                          color="#a07800"
                          style="max-width: 500px"
                          class="ma-auto"
                          outlined
                          hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                          clearable
                        ></v-textarea>
                        <v-layout>
                          <v-spacer></v-spacer>
                          <v-spacer></v-spacer>
                          <v-btn
                            :disabled="!tempListItem"
                            rounded
                            outlined
                            color="green"
                            samll
                            @click="addResponseToList(i)"
                          >
                            <v-icon>mdi-plus</v-icon>ADD
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-layout>

                        <v-layout column class="ma-2">
                          <div class="ma-2 text-center title">Current List</div>
                          <div
                            class="ma-2 text-center subtitle-1"
                            v-for="(r, index) in q.dependantQuestion.response"
                            :key="index"
                          >
                            {{ index + 1 }} - {{ r }}
                            <v-btn
                              class="ma-2"
                              rounded
                              outlined
                              color="red"
                              small
                              @click="removeResponseFromList(i, index)"
                              >remove</v-btn
                            >
                          </div>
                        </v-layout>
                      </div>
                      <div
                        v-if="
                          q.dependantQuestion.type === 'optionsExclusiveBool'
                        "
                      >
                        <v-radio-group v-model="q.dependantQuestion.response">
                          <v-radio label="YES" value="true"></v-radio>
                          <v-radio
                            label="NO"
                            value="false"
                            @click="clearDependantSubQuestionResponse(i)"
                          ></v-radio>
                        </v-radio-group>
                        <v-expand-transition>
                          <div v-if="q.dependantQuestion.response === 'true'">
                            <v-radio-group
                              v-model="q.dependantQuestion.optionResponse"
                            >
                              <div
                                v-for="(option, index) in q.dependantQuestion
                                  .options"
                                :key="index"
                              >
                                <v-radio
                                  :label="option"
                                  :value="option"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                            <div
                              v-if="q.dependantQuestion.subDependantQuestion"
                            >
                              <div
                                class="ma-4 title font-weight-regular text-center"
                              >
                                {{
                                  q.dependantQuestion.subDependantQuestion.text
                                }}
                              </div>
                              <div
                                v-if="
                                  q.dependantQuestion.subDependantQuestion
                                    .type === 'subListOfNames'
                                "
                              >
                                <v-text-field
                                  :rules="[rules.length(1400)]"
                                  counter="1400"
                                  label="Place Your Response Here"
                                  v-model="tempListItem"
                                  color="#a07800"
                                  style="max-width: 500px"
                                  class="ma-auto"
                                  outlined
                                  hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                  clearable
                                ></v-text-field>
                                <v-layout>
                                  <v-spacer></v-spacer>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    :disabled="!tempListItem"
                                    rounded
                                    outlined
                                    color="green"
                                    samll
                                    @click="addSubDependantResponseToList(i)"
                                  >
                                    <v-icon>mdi-plus</v-icon>ADD
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                </v-layout>

                                <v-layout column class="ma-2">
                                  <div class="ma-2 text-center title">
                                    Current List
                                  </div>
                                  <div
                                    class="ma-2 text-center subtitle-1"
                                    v-for="(r, index) in q.dependantQuestion
                                      .subDependantQuestion.response"
                                    :key="index"
                                  >
                                    {{ index + 1 }} - {{ r }}
                                    <v-btn
                                      class="ma-2"
                                      rounded
                                      outlined
                                      color="red"
                                      small
                                      @click="
                                        removeSubDependantResponseFromList(
                                          i,
                                          index
                                        )
                                      "
                                      >remove</v-btn
                                    >
                                  </div>
                                </v-layout>
                              </div>
                            </div>
                          </div>
                        </v-expand-transition>
                      </div>
                    </div>
                  </v-expand-transition>
                </v-card-text>
                <v-card-text v-if="q.type === 'dependantBoolFalse'">
                  <div class="ma-4 title font-weight-regular">{{ q.text }}</div>
                  <v-radio-group v-model="q.response">
                    <v-radio label="YES" value="true"></v-radio>
                    <v-radio
                      label="NO"
                      value="false"
                      @click="clearDependantQuestionResponse(i)"
                    ></v-radio>
                  </v-radio-group>
                  <v-expand-transition>
                    <div v-if="q.response === 'false'">
                      <div class="ma-4 title font-weight-regular">
                        {{ q.dependantQuestion.text }}
                      </div>
                      <div v-if="q.dependantQuestion.type === 'textArea'">
                        <v-textarea
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          color="primary"
                          style="max-width: 700px"
                          auto-grow
                          class="ma-2"
                          outlined
                          label="Place Your Response Here"
                          v-model="q.dependantQuestion.response"
                          clearable
                        ></v-textarea>
                      </div>
                      <div v-if="q.dependantQuestion.type === 'subListOfNames'">
                        <v-textarea
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          label="Place Your Response Here"
                          v-model="tempListItem"
                          color="primary"
                          style="max-width: 500px"
                          class="ma-2"
                          outlined
                          hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                          clearable
                        ></v-textarea>
                        <v-layout>
                          <v-btn
                            :disabled="!tempListItem"
                            rounded
                            color="green"
                            @click="addResponseToList(i)"
                          >
                            <v-icon>mdi-plus</v-icon>ADD
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-layout>

                        <v-layout column class="ma-2">
                          <div class="ma-2 text-center title">Current List</div>
                          <div
                            class="ma-2 text-center subtitle-1"
                            v-for="(r, index) in q.dependantQuestion.response"
                            :key="index"
                          >
                            {{ index + 1 }} - {{ r }}
                            <v-btn
                              class="ma-2"
                              rounded
                              outlined
                              color="red"
                              small
                              @click="removeResponseFromList(i, index)"
                              >remove</v-btn
                            >
                          </div>
                        </v-layout>
                      </div>
                      <div
                        v-if="
                          q.dependantQuestion.type === 'optionsExclusiveBool'
                        "
                      >
                        <v-radio-group v-model="q.dependantQuestion.response">
                          <v-radio label="YES" value="true"></v-radio>
                          <v-radio
                            label="NO"
                            value="false"
                            @click="clearDependantSubQuestionResponse(i)"
                          ></v-radio>
                        </v-radio-group>
                        <v-expand-transition>
                          <div v-if="q.dependantQuestion.response === 'true'">
                            <v-radio-group
                              v-model="q.dependantQuestion.optionResponse"
                            >
                              <div
                                v-for="(option, index) in q.dependantQuestion
                                  .options"
                                :key="index"
                              >
                                <v-radio
                                  :label="option"
                                  :value="option"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                            <div
                              v-if="q.dependantQuestion.subDependantQuestion"
                            >
                              <div class="ma-4 title font-weight-regular">
                                {{
                                  q.dependantQuestion.subDependantQuestion.text
                                }}
                              </div>
                              <div
                                v-if="
                                  q.dependantQuestion.subDependantQuestion
                                    .type === 'subListOfNames'
                                "
                              >
                                <v-textarea
                                  :rules="[rules.length(1400)]"
                                  counter="1400"
                                  label="Place Your Response Here"
                                  v-model="tempListItem"
                                  color="primary"
                                  style="max-width: 500px"
                                  class="ma-2"
                                  outlined
                                  hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                  clearable
                                ></v-textarea>
                                <v-layout>
                                  <v-btn
                                    :disabled="!tempListItem"
                                    rounded
                                    color="green"
                                    @click="addSubDependantResponseToList(i)"
                                  >
                                    <v-icon>mdi-plus</v-icon>ADD
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                </v-layout>

                                <v-layout column class="ma-2">
                                  <div class="ma-2 text-center title">
                                    Current List
                                  </div>
                                  <div
                                    class="ma-2 text-center subtitle-1"
                                    v-for="(r, index) in q.dependantQuestion
                                      .subDependantQuestion.response"
                                    :key="index"
                                  >
                                    {{ index + 1 }} - {{ r }}
                                    <v-btn
                                      class="ma-2"
                                      rounded
                                      outlined
                                      color="red"
                                      small
                                      @click="
                                        removeSubDependantResponseFromList(
                                          i,
                                          index
                                        )
                                      "
                                      >remove</v-btn
                                    >
                                  </div>
                                </v-layout>
                              </div>
                            </div>
                          </div>
                        </v-expand-transition>
                      </div>
                    </div>
                  </v-expand-transition>
                </v-card-text>
                <v-card-text v-if="q.type === 'boolDependantSetMultipleAnswer'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>
                  <v-radio-group v-model="q.response">
                    <v-radio label="YES" value="true"></v-radio>
                    <v-radio
                      label="NO"
                      value="false"
                      @click="clearDependantSetResponse(i)"
                    ></v-radio>
                  </v-radio-group>
                  <div v-if="q.response === 'true'">
                    <div v-for="(dq, index) in q.dependantSet" :key="index">
                      <div class="ma-4 title font-weight-regular text-center">
                        {{ dq.text }}
                      </div>
                      <div v-if="dq.type === 'textArea'">
                        <v-textarea
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          color="#a07800"
                          style="max-width: 700px"
                          class="ma-auto"
                          outlined
                          label="Place Your Response Here"
                          v-model="tempSetResponses[`${dq.model}`]"
                          clearable
                          auto-grow
                        ></v-textarea>
                      </div>

                      <div v-if="dq.type === 'textField'">
                        <v-text-field
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          color="#a07800"
                          style="max-width: 500px"
                          class="ma-auto"
                          outlined
                          label="Place Your Response Here"
                          v-model="tempSetResponses[`${dq.model}`]"
                          clearable
                        ></v-text-field>
                      </div>
                      <div v-if="dq.type === 'boolDependantSet'">
                        <v-radio-group
                          v-model="tempSetResponses[`${dq.model}`]"
                        >
                          <v-radio label="YES" value="true"></v-radio>
                          <v-radio
                            label="NO"
                            value="false"
                            @click="clearSubDependantSetResponse(i, index)"
                          ></v-radio>
                        </v-radio-group>
                        <div v-if="tempSetResponses[`${dq.model}`] === 'true'">
                          <div
                            v-for="(subDQ, index) in dq.dependantSet"
                            :key="index"
                          >
                            <div
                              class="ma-4 title font-weight-regular text-center"
                            >
                              {{ subDQ.text }}
                            </div>
                            <div v-if="subDQ.type === 'textArea'">
                              <v-textarea
                                :rules="[rules.length(1400)]"
                                counter="1400"
                                color="#a07800"
                                style="max-width: 700px"
                                class="ma-auto"
                                outlined
                                label="Place Your Response Here"
                                v-model="tempSetResponses[`${subDQ.model}`]"
                                clearable
                                auto-grow
                              ></v-textarea>
                            </div>
                            <div v-if="subDQ.type === 'textField'">
                              <v-text-field
                                color="#a07800"
                                style="max-width: 500px"
                                class="ma-auto"
                                outlined
                                label="Place Your Response Here"
                                v-model="tempSetResponses[`${subDQ.model}`]"
                                clearable
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <v-btn @click="addDependantSetResponse(i)">ADD</v-btn>
                  <v-layout column class="ma-2">
                    <div class="ma-2 text-center title">Current List</div>
                    <div
                      class="ma-2 text-center subtitle-1"
                      v-for="(r, index) in clientResponses[i].setResponses"
                      :key="index"
                    >
                      {{ index + 1 }} - {{ r }}
                      <v-btn
                        class="ma-2"
                        rounded
                        outlined
                        color="red"
                        small
                        @click="removeSetResponse(i, index)"
                        >remove</v-btn
                      >
                    </div>
                  </v-layout>
                </v-card-text>
                <v-card-text v-if="q.type === 'boolDependantSet'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>
                  <v-radio-group v-model="q.response">
                    <v-radio label="YES" value="true"></v-radio>
                    <v-radio
                      label="NO"
                      value="false"
                      @click="clearDependantSetResponse(i)"
                    ></v-radio>
                  </v-radio-group>
                  <div v-if="q.response === 'true'">
                    <div v-for="(dq, index) in q.dependantSet" :key="index">
                      <div class="ma-4 title font-weight-regular text-center">
                        {{ dq.text }}
                      </div>
                      <div v-if="dq.type === 'textArea'">
                        <v-textarea
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          color="#a07800"
                          style="max-width: 700px"
                          class="ma-auto"
                          outlined
                          label="Place Your Response Here"
                          v-model="dq.response"
                          clearable
                          auto-grow
                        ></v-textarea>
                      </div>

                      <div v-if="dq.type === 'textField'">
                        <v-text-field
                          :rules="[rules.length(1400)]"
                          counter="1400"
                          color="#a07800"
                          style="max-width: 500px"
                          class="ma-auto"
                          outlined
                          label="Place Your Response Here"
                          v-model="dq.response"
                          clearable
                        ></v-text-field>
                      </div>
                      <div v-if="dq.type === 'boolDependantSet'">
                        <v-radio-group v-model="dq.response">
                          <v-radio label="YES" value="true"></v-radio>
                          <v-radio
                            label="NO"
                            value="false"
                            @click="clearSubDependantSetResponse(i, index)"
                          ></v-radio>
                        </v-radio-group>
                        <div v-if="dq.response === 'true'">
                          <div
                            v-for="(subDQ, index) in dq.dependantSet"
                            :key="index"
                          >
                            <div
                              class="ma-4 title font-weight-regular text-center"
                            >
                              {{ subDQ.text }}
                            </div>
                            <div v-if="subDQ.type === 'textArea'">
                              <v-textarea
                                :rules="[rules.length(1400)]"
                                counter="1400"
                                color="#a07800"
                                style="max-width: 700px"
                                class="ma-auto"
                                outlined
                                label="Place Your Response Here"
                                v-model="subDQ.response"
                                clearable
                                auto-grow
                              ></v-textarea>
                            </div>
                            <div v-if="subDQ.type === 'textField'">
                              <v-text-field
                                :rules="[rules.length(1400)]"
                                counter="1400"
                                color="#a07800"
                                style="max-width: 500px"
                                class="ma-auto"
                                outlined
                                label="Place Your Response Here"
                                v-model="subDQ.response"
                                clearable
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-card-text v-if="q.type === 'clientSignature'">
                  <div class="ma-4 title font-weight-regular text-center">
                    {{ q.text }}
                  </div>
                  <div
                    class="ma-4 title font-weight-regular text-center"
                    v-if="q.response"
                  >
                    SIGNATURE ON FILE
                  </div>
                  <div
                    class="ma-4 title font-weight-regular text-center"
                    v-else
                  >
                    NO SIGNATURE ON FILE
                  </div>
                </v-card-text>
              </v-window-item>
            </div>
          </v-window>
          <v-divider></v-divider>

          <v-card-actions>
            <v-btn :disabled="windowStep === 1" text @click="windowStep--"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn rounded outlined dark color="#18CAE6" @click="saveEdits"
              >SAVE EDITS</v-btn
            >
            <v-spacer></v-spacer>
            <!-- <v-btn @click="addDataToClient">ADD THIS DATA TO CLIENT</v-btn> -->
            <!-- <v-spacer></v-spacer> -->
            <v-btn
              :disabled="windowStep === windowSteps"
              color="primary"
              depressed
              @click="windowStep++"
              rounded
              outlined
              dark
              >Next</v-btn
            >

            <!-- experimental -->
            <!-- <v-btn
                          :disabled="windowStep === windowSteps"
                          color="primary"
                          depressed
                          @click="saveAndContinue"
                          rounded
                          outlined
                          dark
                          >Next</v-btn
            >-->
          </v-card-actions>

          <hr
            size="1px"
            color="#18CAE6"
            style="width: 75%"
            class="ml-auto mr-auto mt-3 mb-3"
          />
          <div class="ma-4 title font-weight-regular text-center">
            DOCUMENT UPLOADER
            <v-icon @click="showDocs = true" v-if="!showDocs"
              >mdi-arrow-down-bold-circle-outline</v-icon
            >
            <v-icon @click="showDocs = false" v-if="showDocs"
              >mdi-arrow-up-bold-circle-outline</v-icon
            >
          </div>
          <hr
            size="1px"
            color="#18CAE6"
            style="width: 75%"
            class="ml-auto mr-auto mt-3 mb-3"
          />
          <v-expand-transition>
            <v-layout row v-if="showDocs">
              <div style="width: 45%">
                <div
                  v-for="(category, index) in documentCategories"
                  :key="index"
                >
                  <template>
                    <div>
                      <app-admin-doc-uploader-dialog
                        :category="category"
                        :firm_slug="firmSlug"
                        :matter_slug="matterSlug"
                        :client_slug="clientSlug"
                        :client_user="fullName"
                        :storage_path="routePath"
                        :client_form_type="clientFormType"
                        v-on:admin-added-client-doc="getClientDocs"
                      ></app-admin-doc-uploader-dialog>
                    </div>
                  </template>
                </div>
              </div>
              <v-divider vertical></v-divider>
              <div style="width: 50%" v-if="responses.clientDocs">
                <div v-for="(doc, i) in responses.clientDocs" :key="i">
                  <div class="ma-2">
                    {{ doc.name }} -
                    <span
                      v-if="doc.category === 'personalInformation'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: PERSONAL</span
                    >
                    <span
                      v-if="doc.category === 'generalInformation'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: GENERAL</span
                    >
                    <span
                      v-if="doc.category === 'damages'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: DAMAGES</span
                    >
                    <span
                      v-if="doc.category === 'miscellaneous'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: MISCELLANEOUS</span
                    >
                  </div>
                  <v-btn
                    rounded
                    outlined
                    color="red"
                    small
                    @click="removeClientDocument(doc, i)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    outlined
                    color="yellow darken-2"
                    small
                    @click="viewClientDocument(doc)"
                    >view</v-btn
                  >
                </div>
              </div>
              <div style="width: 50%" if="clientDocs">
                <div v-for="(doc, i) in clientDocs" :key="i">
                  <div class="ma-2">
                    {{ doc.name }} -
                    <span
                      v-if="doc.category === 'personalInformation'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: PERSONAL</span
                    >
                    <span
                      v-if="doc.category === 'generalInformation'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: GENERAL</span
                    >
                    <span
                      v-if="doc.category === 'damages'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: DAMAGES</span
                    >
                    <span
                      v-if="doc.category === 'miscellaneous'"
                      class="ma-4 font-weight-regular text-center"
                      >CATEGORY: MISCELLANEOUS</span
                    >
                  </div>
                  <v-btn
                    rounded
                    outlined
                    color="red"
                    small
                    @click="removeClientDocument(doc, i)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    outlined
                    color="blue darken-2"
                    small
                    @click="viewClientDocument(doc)"
                    >view</v-btn
                  >
                </div>
              </div>
            </v-layout>
          </v-expand-transition>
        </v-card>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 *
 *
 * this is essentially the same component as the ClientForm component that the client user sees
 * when they click on the link that is sent to them by the SendClientForm component, except that
 * the responses are not saved everytime the "NEXT" button is clicked
 * its saved when the "save edits" button is clicked.
 *
 *
 * ****Some of this needs to be edited to make it look more like the ClientForm component******
 *
 *
 */

import { mask } from "vue-the-mask";
import * as firebase from "firebase";
import * as moment from "moment";

export default {
  name: "SelectedDocForm",
  props: ["matter", "user", "responses", "doc"],
  directives: {
    mask
  },
  data() {
    return {
      showDocs: true,
      windowStep: 1,
      // windowSteps: this.responses.formDef.windowSteps,
      phoneMask: "(###) ###-####",
      dateMask: "##/##/####",
      rules: {
        // email: value => {
        //   const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //   return pattern.test(value) || "Invalid e-mail.";
        // },
        length: len => v =>
          (v || "").length <= len || `toomany characters - ${len}`
      },

      tempListItem: null,
      tempArray: null,
      tempSetResponses: {},
      dialog: false,
      clientDocs: null
      // clientResponses: this.responses.formDef.responses,
      // documentCategories: this.responses.formDef.documentCategories
    };
  },
  computed: {
    formTitle() {
      if (this.responses.formDef) {
        return this.responses.formDef.formTitle;
      } else {
        return this.responses.name;
      }
    },
    windowSteps() {
      if (this.responses.formDef) {
        return this.responses.formDef.windowSteps;
      } else {
        return this.responses.windowSteps;
      }
    },
    documentCategories() {
      if (this.responses.formDef) {
        return this.responses.formDef.documentCategories;
      } else {
        return this.responses.documentCategories;
      }
    },
    clientResponses() {
      if (this.responses.formDef) {
        return this.responses.formDef.responses;
      } else {
        return this.responses.responses;
      }
    },
    responsesFromStore() {
      return this.$store.getters.responses;
      // return r;
      // return this.responses.formDef.responses;
    },
    viewingPlaintiff() {
      return this.$store.getters.plaintiff;
    },
    clientSlug() {
      if (this.responses.formDef) {
        return this.responses.clientSlug;
      } else {
        return this.responses.partySlug;
      }
    },
    matterSlug() {
      return this.matter.matterSlug;
    },
    firmSlug() {
      return this.user.firmSlug;
    },
    routePath() {
      if (this.responses.formDef) {
        return `firm/${this.user.firmSlug}/matter/${this.matter.matterSlug}/client/${this.responses.clientSlug}`;
        //firm/engstrom-lipscomb-and-lack/matter/woolsey-fire-garcia-john-household-20181108/client/john-garcia-310-3170600
      } else {
        return `client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.responses.partySlug}`;
        // client/engstrom-lipscomb-and-lack/a-v-b-20190522/first-plaintiff-111-1111111/woolsey-fire-cases-jccp-5000-personal-claims/3jwecm2wUVYEX7reSTxo
      }
    },
    clientFormType() {
      if (this.responses.formDef) {
        return `old`;
        //firm/engstrom-lipscomb-and-lack/matter/woolsey-fire-garcia-john-household-20181108/client/john-garcia-310-3170600
      } else {
        return `new_1`;
        // client/engstrom-lipscomb-and-lack/a-v-b-20190522/first-plaintiff-111-1111111/woolsey-fire-cases-jccp-5000-personal-claims/3jwecm2wUVYEX7reSTxo
      }
    },
    fullName() {
      if (this.responses.formDef) {
        return this.responses.fullName;
      } else {
        return this.responses.partyName;
      }
    }
    // computedClientDocs() {
    //   if (this.responses.formDef) {
    //     return null;
    //   } else {
    //     let list = [];
    //     firebase
    //       .firestore()
    //       .collection("firms")
    //       .doc(this.firmSlug)
    //       .collection("matters")
    //       .doc(this.matterSlug)
    //       .collection("clients")
    //       .doc(this.clientSlug)
    //       .get()
    //       .then(client => {
    //         let tempClient = client.data();
    //         return list = tempClient.clientDocs;
    //       });
    //   }
    // }
  },
  methods: {
    // emptyEditor(){

    // },
    viewClientDocument(doc) {
      window.open(doc.url, doc.name, "resizable,scrollbars,status");
    },
    removeClientDocument(doc, i) {
      console.log("removing this document", doc);
      console.log("document index", i);

      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.firmSlug)
        .collection("matters")
        .doc(this.matterSlug)
        .collection("clients")
        .doc(this.clientSlug)
        .update({
          clientDocs: firebase.firestore.FieldValue.arrayRemove(doc)
        })
        .then(() => {
          let ref = firebase
            .storage()
            .ref(`/${this.routePath}/${doc.category}/${doc.name}`);
          //     let ref;
          //     if(this.responses.formDef){
          //       ref = firebase
          //       .storage()

          //       .ref(
          //         `firm/${this.firmSlug}/matter/${this.matterSlug}/client/${this.clientSlug}/${doc.category}/${doc.name}`
          //       );
          //     } else if (doc.origin)
          // else {
          //       ref = firebase
          //       .storage()

          //       .ref(
          //         doc.user.link
          //       );
          //     }

          ref
            .delete()
            // .then(() => {
            //   console.log(`doc deleted`);
            //   // if (!this.responses.formDef) {
            //   firebase
            //     .firestore()
            //     .collection("firms")
            //     .doc(this.user.firmSlug)
            //     .collection("matters")
            //     .doc(this.matter.matterSlug)
            //     .collection("clients")
            //     .doc(this.responses.partySlug)
            //     .get()
            //     .then(client => {
            //       let data = client.data();
            //       this.clientDocs = data.clientDocs;
            //     });
            //   // }
            // })

            .catch(e => console.log(e));
        })
        .catch(e => console.log(e));
    },
    saveEdits() {
      console.log("clientResponses: ", this.clientResponses);
      // console.log("responses from props ", this.responses.formDef.responses);
      console.log("responses from store: ", this.responsesFromStore);
      //older client objects - now obsolete
      if (this.responses.formDef) {
        firebase
          .firestore()
          // .collection("firms")
          // .doc(this.firmSlug)
          .collection("matters")
          .doc(this.matterSlug)
          .collection("clients")
          .doc(this.clientSlug)

          //experimental
          .update({
            "formDef.responses": this.clientResponses,
            "formDef.responseEdited": moment().format("MMMM Do YYYY, h:mm:ss a")
          });
      }
      if (this.responses.responses) {
        // console.log("resps", this.responses);
        // console.log("firm", this.firmSlug);
        // console.log("matter", this.matterSlug);
        // console.log("client", this.clientSlug);
        firebase
          .firestore()
          // .collection("firms")
          // .doc(this.firmSlug)
          .collection("matters")
          .doc(this.matterSlug)
          .collection("clients")
          .doc(this.responses.partySlug)
          .collection("formList")
          .doc(this.responses.id)
          .update({
            responses: this.clientResponses,
            responseEdited: moment().format("MMMM Do YYYY, h:mm:ss a")
          });
      }
      // firebase
      //   .firestore()
      //   .collection("firms")
      //   .doc(this.firmSlug)
      //   .collection("matters")
      //   .doc(this.matterSlug)
      //   .collection("clients")
      //   .doc(this.clientSlug)

      //   //experimental
      //   .update({
      //     "formDef.responses": this.clientResponses,
      //     "formDef.responseEdited": moment().format("MMMM Do YYYY, h:mm:ss a")
      //   });
    },
    addDataToClient() {
      this.clientResponses.forEach(resp => {
        console.log(resp.model);
        let obj = new Object();
        obj[`${resp.model}`] = resp.response;
        console.log(obj);
      });
    },
    removeResponseFromList(i, index) {
      console.log(i);
      if (this.clientResponses[i].dependantQuestion) {
        this.clientResponses[i].dependantQuestion.response.splice(index, 1);
      } else {
        this.clientResponses[i].response.splice(index, 1);
      }
    },
    addResponseToList(i) {
      if (this.clientResponses[i].dependantQuestion) {
        this.clientResponses[i].dependantQuestion.response.push(
          this.tempListItem
        );
        this.tempListItem = null;
      } else {
        this.clientResponses[i].response.push(this.tempListItem);
        this.tempListItem = null;
      }

      console.log("responselist", this.clientResponses);
      console.log("tempListItem", this.tempListItem);
    },
    addSubDependantResponseToList(i) {
      this.clientResponses[
        i
      ].dependantQuestion.subDependantQuestion.response.push(this.tempListItem);
      this.tempListItem = null;
    },
    addDependantSetResponse(i) {
      this.clientResponses[i].setResponses.push(this.tempSetResponses);
      console.log("responses", this.clientResponses);

      this.tempSetResponses = {};
      window.scrollTo({
        top: 100,
        left: 100,
        behavior: "smooth"
      });
    },
    removeSubDependantResponseFromList(i, index) {
      this.clientResponses[
        i
      ].dependantQuestion.subDependantQuestion.response.splice(index, 1);
    },
    clearDependantQuestionResponse(i) {
      this.clientResponses[i].response = "false";
      this.clientResponses[i].dependantQuestion.response = [];
    },
    clearDependantSetResponse(i) {
      this.clientResponses[i].response = "false";
    },
    clearSubDependantSetResponse(i, index) {
      this.clientResponses[i].dependantSet[index].response = "false";
    },
    clearDependantSubQuestionResponse(i) {
      this.clientResponses[i].dependantQuestion.response = "false";
      this.clientResponses[
        i
      ].dependantQuestion.subDependantQuestion.response = [];
    },
    removeSetResponse(i, index) {
      this.clientResponses[i].setResponses.splice(index, 1);
    },
    getClientDocs() {
      if (!this.responses.formDef) {
        firebase
          .firestore()
          // .collection("firms")
          // .doc(this.user.firmSlug)
          .collection("matters")
          .doc(this.matter.matterSlug)
          .collection("clients")
          .doc(this.responses.partySlug)
          .get()
          .then(client => {
            let data = client.data();
            this.clientDocs = data.clientDocs;
          });
      }
    }
  },
  created() {
    console.log("created");
    console.log("matter", this.matter);
    console.log("user", this.user);
    console.log("responses", this.responses);
    // if (!this.responses.formDef) {
    //   firebase
    //     .firestore()
    //     .collection("firms")
    //     .doc(this.user.firmSlug)
    //     .collection("matters")
    //     .doc(this.matter.matterSlug)
    //     .collection("clients")
    //     .doc(this.responses.partySlug)
    //     .get()
    //     .then(client => {
    //       let data = client.data();
    //       this.clientDocs = data.clientDocs;
    //     });
    // }

    if (!this.responses.formDef) {
      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .collection("clients")
        .doc(this.responses.partySlug)
        .onSnapshot(res => {
          // const changes = res.docChanges();
          // console.log("all changes", changes);
          let data = res.data();
          this.clientDocs = data.clientDocs;
        });
      // .then(client => {
      //   let data = client.data();
      //   this.clientDocs = data.clientDocs;
      // });
    }

    // firebase.firestore()

    // if (this.responses.formDef) {
    //     return null;
    //   } else {
    //     let list = [];
    //     firebase
    //       .firestore()
    //       .collection("firms")
    //       .doc(this.firmSlug)
    //       .collection("matters")
    //       .doc(this.matterSlug)
    //       .collection("clients")
    //       .doc(this.clientSlug)
    //       .get()
    //       .then(client => {
    //         let tempClient = client.data();
    //         return list = tempClient.clientDocs;
    //       });
    //   }
    // }
  }
};

/*
doc form should be determined by the document the user wants to create.
*/
</script>

<style lang="scss" scoped></style>
